import { APIClient } from "@/utils/httpClient";

/**
 * Increment action points
 * @param campaignID - The campaign ID
 * @param userID - The user ID
 * @param actionPoints - The number of action points to increment
 */
export const incrementActionPoints = async (
    campaignID: string,
    userID: string,
    actionPoints: number
): Promise<void> => {
    try {
        const endpoint = `/campaigns/${campaignID}/users/${userID}/action-points/increment`;
        const response = await APIClient.post(endpoint, {
            points: actionPoints,
        });
        if (response?.success) {
            return;
        }
        throw new Error("Failed to increment action points");
    } catch (error) {
        console.error(error);
    }
};

/**
 * Decrement action points
 * @param campaignID - The campaign ID
 * @param userID - The user ID
 * @param actionPoints - The number of action points to decrement
 */
export const decrementActionPoints = async (
    campaignID: string,
    userID: string,
    actionPoints: number
): Promise<void> => {
    try {
        const endpoint = `/campaigns/${campaignID}/users/${userID}/action-points/decrement`;
        const response = await APIClient.post(endpoint, {
            points: actionPoints,
        });
        if (response?.success) {
            return;
        }
        throw new Error("Failed to decrement action points");
    } catch (error) {
        console.error(error);
    }
};
